// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".change-payment-wrapper p[data-v-72b292f9]{padding-top:20px;font-size:1.2rem;line-height:16px;color:var(--color-text-70)}.change-payment-wrapper p a[data-v-72b292f9]{color:var(--color-primary);text-decoration:underline}", ""]);
// Exports
module.exports = exports;
